import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, Users, Brain, TrendingUp, X, Zap, Shield, Clock, Package, Truck, Bot, Globe, Timer } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const LandingFeatures = () => {
  const { t } = useTranslation();
  const icons = [Package, Brain, Zap, Users, Timer];
  const benefitsData = (t('landing.features.heroBenefits', { returnObjects: true }) as Array<{ title: string; description: string }>);
  const heroBenefits = benefitsData.map((b, i) => ({
    icon: icons[i] || Package,
    title: b.title,
    description: b.description
  }));


  return (
    <section className="py-16 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">{t('landing.features.title')}</h2>
          <p className="text-xl text-muted-foreground">{t('landing.features.subtitle')}</p>
        </div>
        
        {/* Why Shohnat Benefits */}
        <div className="grid md:grid-cols-2 lg:flex lg:flex-wrap lg:justify-center gap-6 lg:gap-12 mb-16 animate-fade-in-up items-stretch">
          {heroBenefits.map((benefit, index) => (
            <div key={index} className="flex flex-col items-center text-center h-full lg:w-1/3">
              <div className="w-16 h-16 bg-gradient-to-r from-[hsl(171,78%,60%)] to-[hsl(195,85%,56%)] rounded-full flex items-center justify-center mx-auto mb-4">
                <benefit.icon className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2">{benefit.title}</h3>
              <p className="text-muted-foreground">{benefit.description}</p>
            </div>
          ))}
        </div>

        
        {/* Problem vs Solution */}
        <div className="animate-fade-in">
          <div className="grid md:grid-cols-2 gap-8">
            <Card className="border-red-200 bg-red-50/50 hover-scale">
              <CardContent className="p-8">
                  <h3 className="text-2xl font-bold text-red-700 mb-6 flex items-center gap-3">
                    <X className="h-6 w-6" />
                    {t('landing.features.problems.title')}
                </h3>
                  <div className="space-y-4">
                    {(t('landing.features.problems.items', { returnObjects: true }) as string[]).map((item, index) => (
                      <div key={index} className="flex items-start gap-3">
                        <div className="w-2 h-2 bg-red-500 rounded-full mt-2"></div>
                        <p className="text-muted-foreground">{item}</p>
                      </div>
                    ))}
                  </div>
              </CardContent>
            </Card>
            
            <Card className="border-green-200 bg-green-50/50 hover-scale">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-green-700 mb-6 flex items-center gap-3">
                  <CheckCircle className="h-6 w-6" />
                  {t('landing.features.solutions.title')}
                </h3>
                <div className="space-y-4">
                  {(t('landing.features.solutions.items', { returnObjects: true }) as string[]).map((item, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 text-green-500 mt-1" />
                      <p className="text-muted-foreground">{item}</p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};